import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=213ce4d8&scoped=true"
import script from "./CertificatePage.vue?vue&type=script&lang=js"
export * from "./CertificatePage.vue?vue&type=script&lang=js"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&id=213ce4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ce4d8",
  null
  
)

export default component.exports